import { useStaticPermissions } from "../hooks/usePermissions"

export const PermissionArea = ({ name, children, elseChildren = null }) => {
  const { hasPermission } = useStaticPermissions();

  if (hasPermission({ name })) {
    return children;
  } else {
    if(elseChildren) return elseChildren;
  }

  return null;
}